import { render, staticRenderFns } from "./ListaUnidade.vue?vue&type=template&id=61418c0d&scoped=true"
import script from "./ListaUnidade.vue?vue&type=script&lang=js"
export * from "./ListaUnidade.vue?vue&type=script&lang=js"
import style0 from "./ListaUnidade.vue?vue&type=style&index=0&id=61418c0d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61418c0d",
  null
  
)

export default component.exports